import React from "react";
import { node, string } from "prop-types";
import { Col } from "../Grid";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";

const ErrorLabelText = ({ className = "", children, ...props }) => (
	<span className={classes("error-label__wrap", className)} {...props}>
		<span className="error-label__wrap-text">{children}</span>
	</span>
);

ErrorLabelText.propTypes = {
	className: string,
	children: node.isRequired,
};

const ErrorLabel = ({ className = "", children, ...props }) => (
	<Col Tag="span" className={classes("field--error", className)} {...props}>
		{children}
	</Col>
);

ErrorLabel.propTypes = {
	className: string,
	children: node.isRequired,
};

ErrorLabel.Text = ErrorLabelText;

export default pureFC(ErrorLabel);
